import { getAuth, GoogleAuthProvider } from "firebase/auth";
import {
  clearIndexedDbPersistence,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  terminate,
} from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Firebase services
export const auth = getAuth(app);
// Lokális (IndexedDB) cache: a valós idejű figyelők (onSnapshot) visszatéréskor először a
// cache-ből adnak adatot, így az admin foglaláslista azonnal megjelenik, és a szerver csak a
// változásokat küldi - nem töltődik le újra a teljes kollekció minden oldalbetöltéskor. A fülek
// osztoznak a cache-en. Ha az IndexedDB nem elérhető (pl. privát böngészés), az SDK
// figyelmeztetéssel memória-cache-re vált, a működés változatlan.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});

/**
 * Kijelentkezéskor hívandó: a helyi cache-ben az admin által látott adatok (foglalások,
 * ügyféllista) is ott vannak, közös gépen ez nem maradhat ott. A terminate után a Firestore
 * példány nem használható, ezért a hívó teljes újratöltéssel folytatja. Ha egy másik fül még
 * használja a cache-t, a törlés nem lehetséges - az a fül a saját kijelentkezésekor törli.
 */
export async function clearLocalCache(): Promise<void> {
  try {
    await terminate(db);
    await clearIndexedDbPersistence(db);
  } catch (error) {
    console.warn("A helyi Firestore cache törlése nem sikerült:", error);
  }
}
export const storage = getStorage(app);

// A Cloud Functions régiója. Alapértelmezésben az SDK us-central1-et hív, a függvények viszont
// a Firestore mellett, Európában futnak - szerveroldali párja: functions/src/lib/region.js
// (REGION), a kettőt együtt kell módosítani.
export const functions = getFunctions(app, "europe-west1");

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});
